export const API_URL = 'https://api.tokfluence.com/affiliates';
// export const API_URL = 'http://localhost:3974';

export default API_URL;
